/**
 * Model configuration
 */
export const config = {
  modelName: 'user',
} as const;
